import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  ReleasePlanResult,
  ReleaseResultsFilters,
  ReleaseResultsSummary,
  ReleaseRuns,
} from '../models/release-results.model';

@Injectable({ providedIn: 'root' })
export class ReleaseResultsService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  getSummary(projectId: string, releaseId: string, filters: ReleaseResultsFilters): Observable<ReleaseResultsSummary> {
    return this.http.get<ReleaseResultsSummary>(this.resultsUrl(projectId, releaseId, 'summary'), {
      params: this.filterParams(filters),
    });
  }

  getPlans(projectId: string, releaseId: string, filters: ReleaseResultsFilters): Observable<ReleasePlanResult[]> {
    return this.http.get<ReleasePlanResult[]>(this.resultsUrl(projectId, releaseId, 'plans'), {
      params: this.filterParams(filters),
    });
  }

  getRuns(
    projectId: string,
    releaseId: string,
    filters: ReleaseResultsFilters,
    planKey: string | null,
  ): Observable<ReleaseRuns> {
    let params = this.filterParams(filters);
    if (planKey) params = params.set('planKey', planKey);
    return this.http.get<ReleaseRuns>(this.resultsUrl(projectId, releaseId, 'runs'), { params });
  }

  private resultsUrl(projectId: string, releaseId: string, resource: string): string {
    return `${this.base}/${projectId}/releases/${encodeURIComponent(releaseId)}/results/${resource}`;
  }

  private filterParams(filters: ReleaseResultsFilters): HttpParams {
    let params = new HttpParams();
    if (filters.umgebung) params = params.set('umgebung', filters.umgebung);
    if (filters.environment) params = params.set('environment', filters.environment);
    if (filters.source) params = params.set('source', filters.source);
    return params;
  }
}
